import React, { useState, useCallback, useEffect } from 'react';

import ColorPicker from '../../components/colorPicker';

import {
  Container,
  GroupBox,
  GroupBoxLegenda,
  ContainerInputs,
  InputDescricao,
  BotaoExcluir,
  BotaoLimpar,
  BotaoSalvar,
  BotoesContainer,
  Pesquisa,
  CardLocal,
} from './styles';

import { useToast } from '../../context/ToastContext';

import { FiHome, FiRefreshCw, FiSave, FiTrash2 } from 'react-icons/fi';
import ILocal from '../../routes/vms/ILocal';
import api from '../../services/api';
import { returnAxiosError } from '../../utils/returnAxiosError';

const Local: React.FC = () => {
  const { addToast } = useToast();
  const [descricao, setDescricao] = useState('');
  const [descricaoErro, setDescricaoErro] = useState('');
  const [cor, setCor] = useState('');
  const [locais, setLocais] = useState<ILocal[]>([]);
  const [selectedLocal, setSelectedLocal] = useState<ILocal | undefined>(
    undefined,
  );

  const handleCorChange = useCallback((cor: string) => {
    setCor(cor);
  }, []);

  const handleListLocais = useCallback(() => {
    api.get<ILocal[]>('/local/lista').then(response => {
      setLocais(response.data);
    });
  }, []);

  const handleLimparCampos = useCallback(() => {
    setDescricao('');
    setDescricaoErro('');
    setCor('');
    setSelectedLocal(undefined);
  }, []);

  const handleSelecionarLocal = useCallback(
    async (id: string) => {
      try {
        const response = await api.get<ILocal>('/local', {
          params: { id },
        });

        setSelectedLocal(response.data);
        setDescricao(response.data.descricao);
        setCor(response.data.cor);
      } catch (error) {
        addToast(returnAxiosError(error));
      }
    },
    [addToast],
  );

  const handleDeleteLocal = useCallback(async () => {
    try {
      if (!selectedLocal) {
        addToast({
          title: 'Erro ao Excluir',
          description:
            'Nenhum local de atendimento selecionado para a exclusão',
          type: 'error',
        });
      }

      await api.delete(`/local/${selectedLocal?.id}`);

      handleListLocais();

      addToast({
        title: 'Sucesso',
        description: 'Local de atendimento excluído com sucesso',
        type: 'success',
      });
    } catch (error) {
      addToast(returnAxiosError(error));
    }
  }, [selectedLocal, addToast, handleListLocais]);

  const handleSaveLocal = useCallback(async () => {
    setDescricaoErro('');
    if (descricao === '') {
      setDescricaoErro('Informação obrigatória!');
      return;
    }

    try {
      if (selectedLocal) {
        await api.put(`/local/${selectedLocal.id}`, {
          descricao,
          cor,
        });
      } else {
        await api.post('/local', {
          descricao,
          cor,
        });
      }
    } catch (error) {
      addToast(returnAxiosError(error));
      return;
    }

    handleListLocais();
    handleLimparCampos();

    addToast({
      title: 'Sucesso',
      description: 'Local de atendimento salvo com sucesso',
      type: 'success',
    });
  }, [
    descricao,
    cor,
    handleListLocais,
    handleLimparCampos,
    addToast,
    selectedLocal,
  ]);

  useEffect(() => {
    handleListLocais();
  }, [handleListLocais]);

  return (
    <Container>
      <GroupBox>
        <GroupBoxLegenda>Local de Atendimento</GroupBoxLegenda>

        <ContainerInputs>
          <InputDescricao
            variant="outlined"
            margin="normal"
            id="descricao"
            label="Descrição"
            name="descricao"
            type="text"
            value={descricao}
            error={descricaoErro !== ''}
            helperText={descricaoErro}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDescricao(e.target.value)
            }
          />

          <ColorPicker onChange={handleCorChange} cor={cor} />
        </ContainerInputs>

        <Pesquisa>
          {locais.map(local => (
            <CardLocal
              key={local.id}
              cor={local.cor}
              onClick={() => {
                handleSelecionarLocal(local.id);
              }}
            >
              <p>{local.descricao}</p>
              <div>
                <FiHome />
              </div>
            </CardLocal>
          ))}
        </Pesquisa>
      </GroupBox>

      <BotoesContainer>
        <BotaoSalvar onClick={handleSaveLocal}>
          <FiSave />
          Salvar
        </BotaoSalvar>

        <BotaoLimpar onClick={handleLimparCampos}>
          <FiRefreshCw />
          Limpar
        </BotaoLimpar>

        <BotaoExcluir onClick={handleDeleteLocal}>
          <FiTrash2 />
          Excluir
        </BotaoExcluir>
      </BotoesContainer>
    </Container>
  );
};

export default Local;
